<mat-sidenav-container [ngClass]="{'expanded': sidenavExpanded, 'extended': sidenavExtended, 'window': routeService.isWindow, 'hidden': !isAuthorized}">
  <mat-sidenav #sidenav [hidden]="routeService.isWindow" [mode]="'side'"
               [disableClose]="true"
               [opened]="true">
    <ng-container *ngFor="let sidenavItem of sidenavActiveRoute.primaryItems">
      <a class="sidenav-item" *ngIf="sidenavItem.canAccess()" (click)="updatePrevUrl()" [routerLink]="currentRoute + sidenavItem.route"
         [ngClass]="{ 'active': isActive(sidenavItem.route) }">
        <div class="sidenav-item-wrapper">
          <mat-icon class="svg-icon" [svgIcon]="sidenavItem.icon"></mat-icon>
          <span>{{ sidenavItem.label | translate }}</span>
        </div>
      </a>
    </ng-container>
    <ng-container *ngFor="let sidenavCategory of sidenavActiveRoute.primaryCategories">
      <a class="sidenav-item sidenav-category" *ngIf="sidenavCategory.canAccess()"
         [ngClass]="{ 'active': isActiveCategory(sidenavCategory.label) }" (click)="openCategory(sidenavCategory)">
        <div class="sidenav-item-wrapper">
          <mat-icon class="svg-icon" [svgIcon]="sidenavCategory.icon"></mat-icon>
          <span>{{ sidenavCategory.label | translate }}</span>
        </div>
      </a>
    </ng-container>
    <ng-container *ngFor="let sidenavItem of sidenavActiveRoute.items">
      <a class="sidenav-item" *ngIf="sidenavItem.canAccess()" (click)="updatePrevUrl()" [routerLink]="currentRoute + sidenavItem.route"
         [ngClass]="{ 'active': isActive(sidenavItem.route) }">
        <div class="sidenav-item-wrapper">
          <mat-icon class="svg-icon" [svgIcon]="sidenavItem.icon"></mat-icon>
          <span>{{ sidenavItem.label | translate }}</span>
        </div>
      </a>
    </ng-container>
    <ng-container *ngFor="let sidenavCategory of sidenavActiveRoute.categories">
      <a class="sidenav-item sidenav-category" *ngIf="sidenavCategory.canAccess()"
         [ngClass]="{ 'active': isActiveCategory(sidenavCategory.label)}" (click)="openCategory(sidenavCategory)">
        <div class="sidenav-item-wrapper">
          <mat-icon class="svg-icon" [svgIcon]="sidenavCategory.icon"></mat-icon>
          <span>{{ sidenavCategory.label | translate }}</span>
        </div>
      </a>
    </ng-container>
    <div class="sidenav-category-items" *ngIf="sidenavExtended && activeCategory">
      <ng-container *ngFor="let sidenavItem of activeCategory.items">
        <hr *ngIf="sidenavItem.hasSpacer">
        <a class="sidenav-item" *ngIf="sidenavItem.canAccess()" (click)="updatePrevUrl()" [routerLink]="currentRoute + sidenavItem.route"
           [ngClass]="{ 'active': isActive(sidenavItem.route) }">
          <div class="sidenav-item-wrapper">
            <mat-icon class="svg-icon" [svgIcon]="sidenavItem.icon"></mat-icon>
            <span>{{ sidenavItem.label | translate }}</span>
          </div>
        </a>
      </ng-container>
    </div>
    <button mat-button color="primary" class="sidenav-toggle icon-button" (click)="toggleMenu()" *ngIf="!routeService.isWindow">
      <mat-icon class="svg-icon" [svgIcon]="'arrow_right'"></mat-icon>
    </button>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="fiscal-overlay" *ngIf="fiscalService.isOperationPending"></div>
    <div class="fiscal-day-not-started-overlay" *ngIf="hasSpOverlay">
      <div class="overlay-wrapper body-2 text-muted">
        {{ 'general.api_fiscal_day_not_started_description' | translate }}
      </div>
    </div>
    <div class="menu-navbar">
      <div class="menu-wrapper">
        <div class="logo {{viewService.conf.logoClass}}" [ngClass]="{'char': !utilService.isMobile && !sidenavExpanded, 'full': utilService.isMobile || sidenavExpanded}" (click)="!routeService.isWindow && goToHomepage()">
          <img [src]="utilService.isMobile || sidenavExpanded ? viewService.conf.logoFull : viewService.conf.logoCompact">
          <span>{{viewService.conf.environment}}</span>
        </div>
        <div class="menu-tabs" *ngIf="!routeService.isWindow && isAuthorized">
          <ng-container *ngFor="let menuItem of menuItems">
            <a class="menu-item" *ngIf="menuItem.canAccess()" [routerLink]="menuItem.route" routerLinkActive="active">
              <div class="menu-item-wrapper">
                {{ menuItem.label | translate }}
              </div>
            </a>
          </ng-container>
        </div>
        <div class="menu-window-close" *ngIf="routeService.isWindow">
          <button mat-stroked-button color="primary" (click)="closeWindow()">{{'general.api_general_close' | translate}}</button>
        </div>
        <div class="menu-title" *ngIf="routeService.isWindow && (routeService.header.date || cartService.ticketCount)">
          <div class="menu-title-wrapper">
            {{ routeService.header.title }}
            <ng-container *ngIf="routeService.header.date">{{ routeService.header.date | period }}</ng-container>
          </div>
        </div>
        <div class="menu-actions">
          <mat-form-field class="no-hint language-select dynamic-width">
            <mat-select [ngModel]="languageService.selectedLang" (selectionChange)="languageService.changeLang($event.value, true, true)">
              <mat-option *ngFor="let language of languageService.languages" [value]="language">
                {{language.toUpperCase()}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <ng-container *ngIf="!isAuthorized">
            <a [routerLink]="'/login'" class="link sign-in no-wrap">
              <span>{{ 'general.api_general_sign_in' | translate }}</span>
            </a>
          </ng-container>
          <ng-container *ngIf="isAuthorized">
            <app-fiscal-menu></app-fiscal-menu>
            <app-cart-menu [(caller)]="caller"></app-cart-menu>
            <app-user-menu></app-user-menu>
            <a class="menu-icon menu-action" (click)="openNav()" [ngClass]="{'active': navOpen}">
              <mat-icon class="svg-icon menu-action-content" [svgIcon]="'menu'"></mat-icon>
            </a>
          </ng-container>
        </div>
      </div>
    </div>
    <div #pageContent class="page-content" cdk-scrollable (scroll)="onScroll($event)" [ngClass]="{'scrolled': isScrolled, 'overflow-unset': utilService.overflowUnset, 'virtual-keyboard-opened': utilService.virtualKeyboardOpened}" [style]="utilService.virtualKeyboardOpened ? 'height: calc(100% - ' + keyboardHeight + 'px' : ''">
      <div class="page-content-wrapper" [style]="fixedSnackHeight">
        <app-breadcrumb *ngIf="!routeService.isWindow && isAuthorized"></app-breadcrumb>
        <router-outlet (activate)="onActivate($event, outlet)" #outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
